import { render, staticRenderFns } from "./notificationDetail.vue?vue&type=template&id=3e49c3c8&scoped=true"
import script from "./notificationDetail.vue?vue&type=script&lang=js"
export * from "./notificationDetail.vue?vue&type=script&lang=js"
import style0 from "./notificationDetail.vue?vue&type=style&index=0&id=3e49c3c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49c3c8",
  null
  
)

export default component.exports